import { orderBy } from 'lodash';
import { parseEntities } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseUser } from '@/shared/converters/userConverters';
import JobActivity from '../models/JobActivity';

const SCHEMA = {
  createdOn: (data: any) => parseMoment(data.createdOn),
  createdBy: (data: any) => parseUser(data.createdBy),
  category: 'category',
  code: 'code',
  description: 'description',
};

export function parseJobActivities(data: any): Array<JobActivity> {
  return orderBy(parseEntities(data, SCHEMA, JobActivity), 'createdOn', 'desc');
}
